const angular = require('angular');
const amt_admin = require('amt_admin').default;
const app = angular.module('ww2_analytics.players_power', [amt_admin]);

app.config([
  '$stateProvider',
  function($stateProvider) {
    $stateProvider
      .state('amt.ww2.players_power', {
        url: '/players_power',
        template: '<div ui-view></div>',
        reloadOnSearch: false,
        abstract: true,
        data: {
          priority: 700,
          title: 'Players Power',
          role: 'players_power',
        },
        menu: {
          glyphicon: 'user',
          childs: [
            {state: 'amt.ww2.players_power.commanders_levels', glyphicon: 'user'},
            {state: 'amt.ww2.players_power.units_levels', glyphicon: 'user'},
            {state: 'amt.ww2.players_power.equipments_power', glyphicon: 'user'},
            {state: 'amt.ww2.players_power.medals_power', glyphicon: 'user'},
          ],
        },
      })
      .state('amt.ww2.players_power.commanders_levels', require('./commanders_levels').default)
      .state('amt.ww2.players_power.units_levels', require('./units_levels').default)
      .state('amt.ww2.players_power.equipments_power', require('./equipments_power').default)
      .state('amt.ww2.players_power.medals_power', require('./medals_power').default)
      ;
  },
]);

export default app.name;
